import Vue from 'vue';

/**
 * Some links need to be handled via form submit.
 * Original ticket see https://jira.namics.com/browse/OLB-668.
 * @param event click event on the element that the directive is on
 */
function handlePostlinkClick(event: Event) {
	event.preventDefault();
	const el = event.currentTarget as HTMLElement;
	const href = el.getAttribute('href');
	const target = el.getAttribute('target') || '_self';
	const form = document.createElement('form');
	const submitBtn = document.createElement('button');
	submitBtn.setAttribute('type', 'submit');
	form.appendChild(submitBtn);
	form.setAttribute('method', 'post');
	form.setAttribute('class', 'sr-only');
	href && form.setAttribute('action', href);
	form.setAttribute('target', target);
	document.body.appendChild(form);
	form.submit();
	form.remove();
}

export default Vue.directive('postlink', {
	bind(el) {
		el.addEventListener('click', handlePostlinkClick);
	},
});
